module.exports = __webpack_public_path__ + "static/img/134.b5c7b44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200414/134.jpg
// module id = VRrI
// module chunks = 0